(function initMenu($) {
    $(document).ready(() => {
        const $menu = $('#main-menu');
        const $menuButton = $('#toggle-menu');
        const $closeButton = $('#close-menu');

        const showMenu = () => {
            $menu.addClass('active');
        };

        const hideMenu = () => {
            $menu.removeClass('active');
        };

        $menuButton.on('click', (event) => {
            event.stopPropagation();
            showMenu();
        });

        $closeButton.on('click', (event) => {
            event.stopPropagation();
            hideMenu();
        });

        $menu.on('click', (event) => {
            event.stopPropagation();
        });

        $(document).on('click', () => {
            hideMenu();
        });
    });
}(jQuery));

document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (!mutation.addedNodes) return;

            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) return;

                const totalsLabel = node.querySelector('.wc-block-components-totals-item__label');
                if (totalsLabel) {
                    totalsLabel.textContent = 'Totalt belopp inkl. moms';
                    observer.disconnect();
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});
